import React, { PureComponent } from 'react';
import { findDOMNode } from 'react-dom';
import NavDropdown from 'react-bootstrap/lib/NavDropdown';

// Components.
import AdditionalMenuIcon from 'components/Icons/Menu/AdditionalMenuIcon';
import CloseIcon from 'components/Icons/Menu/ExitIcon';
import HeaderMenuAdditionalItems from 'components/HeaderMenuAdditionalItems';

// Styles.
import styles from './styles.module.scss';
import cx from 'classnames';

export default class HeaderMenuAdditional extends PureComponent {

  state = {
    isShowAdditionalMenu: false,
  };

  componentWillMount() {
    document.addEventListener('mousedown', this.onMouseDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.onMouseDown, false);
  }

  onMouseDown = (e) => {
    const headerMenuAdditionalMenu = this.headerMenuAdditionalMenu;
    const headerMenuAdditionalItems = findDOMNode(this.headerMenuAdditionalItems);
    if (this.state.isShowAdditionalMenu === false || headerMenuAdditionalMenu.contains(e.target) || headerMenuAdditionalItems.contains(e.target)) {
      return;
    }
    this.onClickToggleAdditionalMenu();
  };

  onClickToggleAdditionalMenu = () => {
    this.setState({ isShowAdditionalMenu: !this.state.isShowAdditionalMenu });
  };

  render() {
    const { locationPath, userState, isAuthenticated, theme } = this.props;
    const { isShowAdditionalMenu } = this.state;
    const additionalMenuItem = (
      <div
        ref={headerMenuAdditionalMenu => this.headerMenuAdditionalMenu = headerMenuAdditionalMenu}
        key="header-menu-item-additional-menu"
        id="menuAdditionalMenu"
        className={cx(styles.menuItem, styles.menuItemAdditionalMenu)}
        onClick={this.onClickToggleAdditionalMenu}
      >
        <div className={styles.menuItemWrapper}>
          <div className={cx(styles.menuItemIcon)}>
            <AdditionalMenuIcon theme={theme} />
          </div>
        </div>
      </div>
    );
    return (
      <NavDropdown
        title={additionalMenuItem}
        className={cx(styles.userMenu, { [styles.isAuth]: isAuthenticated })}
        id="nav-dropdown"
        noCaret
        bsClass={cx(styles.userMenuList, { [styles.active]: isShowAdditionalMenu }, styles.userMenuListNone)}
      >
        <div className={styles.additionalMenuClose} onClick={this.onClickToggleAdditionalMenu}>
          <CloseIcon />
        </div>
        <HeaderMenuAdditionalItems
          ref={headerMenuAdditionalItems => this.headerMenuAdditionalItems = headerMenuAdditionalItems}
          isAuthenticated={isAuthenticated}
          userState={userState}
          locationPath={locationPath}
          isShow={isShowAdditionalMenu}
          theme={theme}
          payConnectedPackages={this.props.payConnectedPackages}
          onClickAdditionalMenuItem={this.onClickToggleAdditionalMenu}
        />
      </NavDropdown>
    );
  }

}
